export const WARZONE_COIN_IMAGE_URL =
  'https://warzone-server.s3.us-east-1.amazonaws.com/imgs/WarzoneCoin.png'

